import { useEffect, useRef } from 'react';
import { ReduxAction } from '@app/types';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '@reducers/rootReducer';

export const useReduxActionPolling = ({
  selectShouldStartPolling,
  selectShouldEndPolling,
  pollAction,
  pollInterval,
}: {
  selectShouldStartPolling: (state: AppState) => boolean;
  selectShouldEndPolling?: (state: AppState) => boolean;
  pollAction: () => ReduxAction;
  pollInterval?: number;
}) => {
  const dispatch = useDispatch();
  const pollingIntervalRef = useRef(null);
  const shouldStartPolling = useSelector(selectShouldStartPolling);
  let shouldEndPolling = useSelector(selectShouldEndPolling || (() => false));

  if (!selectShouldEndPolling) {
    shouldEndPolling = !shouldStartPolling;
  }

  useEffect(() => {
    if (shouldStartPolling && !pollingIntervalRef.current) {
      pollingIntervalRef.current = setInterval(() => {
        dispatch(pollAction());
      }, pollInterval || 5000);
    } else if (shouldEndPolling && pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }

    return () => clearInterval(pollingIntervalRef.current);
  }, [shouldStartPolling, shouldEndPolling]);
};
